import React from 'react';

export interface ICheckCircleOutlinedProps {
    className?: string;
}

const CheckIcon: React.FC<React.PropsWithChildren<ICheckCircleOutlinedProps>> = ({className = '' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
            <g id="CheckCircleOutlined">
                <path id="Vector" d="M31.9999 5.33337C17.2799 5.33337 5.33325 17.28 5.33325 32C5.33325 46.72 17.2799 58.6667 31.9999 58.6667C46.7199 58.6667 58.6666 46.72 58.6666 32C58.6666 17.28 46.7199 5.33337 31.9999 5.33337ZM31.9999 53.3334C20.2399 53.3334 10.6666 43.76 10.6666 32C10.6666 20.24 20.2399 10.6667 31.9999 10.6667C43.7599 10.6667 53.3333 20.24 53.3333 32C53.3333 43.76 43.7599 53.3334 31.9999 53.3334ZM44.2399 20.2134L26.6666 37.7867L19.7599 30.9067L15.9999 34.6667L26.6666 45.3334L47.9999 24L44.2399 20.2134Z" fill="#2E7D32"/>
            </g>
        </svg>
    );
};

export default CheckIcon;
